import { HighchartsOptions } from '../shared/component/pie-chart-simple/highcharts-common/highcharts-global-const';

export interface AiResponseEvent {
  textChunk?: string;
  json?: string;
}

export class AiChart {
  chartId: string;
  options: HighchartsOptions;
}

export enum MessageType {
  USER = 'USER',
  ASSISTANT = 'ASSISTANT'
}

export class AiHistoryMessage {
  constructor(
    public role: MessageType,
    public text: string = '',
    public isThinking = false,
    public jsonBlocks: string[] = []
  ) {}
}

export class AiChatWithCharts {
  constructor(
    public messages: AiHistoryMessage[] = [],
    public charts: AiChart[] = []
  ) {}
}

export enum DataSourceType {
  ORGANIZATION = 'Organization',
  FUND = 'Fund',
  COMPANY = 'Company',
}

export class AiRequestDto {
  request: string;
}

export class GlobalAiRequestDto extends AiRequestDto {
  dataSourceType: DataSourceType;
  fundsUuids: string[];
  companyUuid: string;
  companyId: number;
  orgUuid: string;
  orgId: number;
  fundId: number;
  period: Date;
}


export interface GlobalAiDebugInfoDto {
  data: string;
  prompt: string;
}

export interface AiHistoryParamType {
  [key: string]: string | number;
}

export function getDefaultAiRequests(dataSourceType: DataSourceType): string[] {
  switch (dataSourceType) {
    case DataSourceType.ORGANIZATION:
      return [
        "Provide a comprehensive overview of the organization's overall performance, including investment trends and portfolio composition.",
        "Identify key strengths and potential risks in the organization’s cash flow and investment schedules.",
        "Summarize the organization's performance metrics and suggest actionable insights for growth.",
      ];
    case DataSourceType.FUND:
      return [
        "Analyze the fund's performance by comparing cash flow trends and portfolio diversification between active and sold investments.",
        "Provide a detailed breakdown of key metrics such as IRR, DPI, RVPI, and TVPI based on the available fund data.",
        "Evaluate the fund’s overall performance and highlight major trends in contributions, distributions, and investment efficiency.",
      ];
    case DataSourceType.COMPANY:
      return [
        "Provide a comprehensive analysis of the company's key performance indicators (KPIs), highlighting strengths and weaknesses.",
        "Compare actual vs. budgeted numbers to give a clear picture of the company's financial performance and cash flow trends.",
        "Summarize the company’s performance and offer insights on growth opportunities and potential financial risks.",
      ];
    default:
      return [];
  }
}
